import React from 'react';
import { Alert, Table } from 'react-bootstrap';

const ReferencesSubcovUpdateResultAlert = ({ result, onDismiss }) => {
    if (!result || typeof result !== 'object') return null;

    const updatedRows = Array.isArray(result.updated_rows) ? result.updated_rows : [];
    const errors = Array.isArray(result.errors) ? result.errors : [];
    const updatedCount = result.updated_count ?? updatedRows.length;
    const hasErrors = errors.length > 0;
    const variant = hasErrors ? (updatedCount > 0 ? 'warning' : 'danger') : 'success';

    return (
        <Alert variant={variant} dismissible={!!onDismiss} onClose={onDismiss} className="mb-0">
            {result.message && (
                <p className="mb-2 fw-semibold">{result.message}</p>
            )}
            <p className="mb-2 small">
                <strong>Lignes mises à jour :</strong> {updatedCount}
                {hasErrors && (
                    <>
                        {' '}
                        · <strong>Erreurs :</strong> {errors.length}
                    </>
                )}
            </p>
            {updatedRows.length > 0 && (
                <div className="table-responsive border rounded bg-white mb-3">
                    <Table striped bordered hover size="sm" className="mb-0 align-middle">
                        <thead className="table-light">
                            <tr>
                                <th>Ligne</th>
                                <th>Référence</th>
                                <th>Code subcoverage</th>
                                <th>reference_id</th>
                                <th>subcoverage_trip_id</th>
                            </tr>
                        </thead>
                        <tbody>
                            {updatedRows.map((row) => (
                                <tr key={`${row.row}-${row.subcoverage_trip_id || row.reference_id}`}>
                                    <td>{row.row ?? '—'}</td>
                                    <td>{row.reference_name ?? '—'}</td>
                                    <td>
                                        <code className="small">{row.subcoverage_trip_code ?? '—'}</code>
                                    </td>
                                    <td>
                                        <code className="small text-break">{row.reference_id ?? '—'}</code>
                                    </td>
                                    <td>
                                        <code className="small text-break">{row.subcoverage_trip_id ?? '—'}</code>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            )}
            {hasErrors && (
                <div>
                    <strong className="small d-block mb-1">Détail des erreurs</strong>
                    <ul className="mb-0 small ps-3">
                        {errors.map((err, index) => (
                            <li key={`ref-subcov-update-err-${index}`} className="text-break">
                                {typeof err === 'string' ? err : JSON.stringify(err)}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </Alert>
    );
};

export default ReferencesSubcovUpdateResultAlert;
